// extracted by mini-css-extract-plugin
export var content = "IconTablePanel-module--content--b2262";
export var headline = "IconTablePanel-module--headline--1a65d";
export var iconCol = "IconTablePanel-module--iconCol--46667";
export var iconItem = "IconTablePanel-module--iconItem--e8861";
export var iconItemIcon = "IconTablePanel-module--iconItemIcon--972b1";
export var iconItemText = "IconTablePanel-module--iconItemText--79a21";
export var iconRow = "IconTablePanel-module--iconRow--04891";
export var wrapper = "IconTablePanel-module--wrapper--1b6b5";